import React from "react";
import parser from "html-react-parser";

export const AnswerView = ({ text, userAns, isCorrect, trueAnswer }) => {
  return (
    <div
      // CR-02/CR-04: matches the live answer boxes - a visible outline at rest instead
      // of a transparent one, and text aligned to the start of the line so the review
      // reads the same way the question did.
      className={`relative  px-7 py-4 bg-white rounded-lg leading-none flex items-center m-2 w-full border-2 text-start ${
        userAns
          ? isCorrect
            ? "border-green-400"
            : "border-red-400"
          : trueAnswer
          ? "border-green-400"
          : "border-slate-300"
      }`}
    >
      <span className="text-lg text-slate-900 text-start w-full">
        {parser(text)}
      </span>
    </div>
  );
};
